import React, { useState } from "react";
import {
  FaHtml5,
  FaCss3Alt,
  FaJs,
  FaAngular,
  FaReact,
  FaVuejs,
  FaPhp,
  FaPython,
  FaNodeJs,
  FaJava,
  FaAws,
} from "react-icons/fa";

import {
  SiDotnet,
  SiMysql,
  SiOnnx,
  SiMariadb,
  SiSqlite,
  SiDjango,
  SiMlflow,
  SiGooglecloud,
  SiMongodb,
  SiPostgresql,
} from "react-icons/si";
import Team from '../../../../assests/servicePage.png'

const tabs = [
  {
    name: "Front End",
    items: [
      { name: "HTML", icon: <FaHtml5 /> },
      { name: "CSS", icon: <FaCss3Alt /> },
      { name: "JavaScript", icon: <FaJs /> },
      { name: "Angular", icon: <FaAngular /> },
      { name: "React", icon: <FaReact /> },
      { name: "Vue.js", icon: <FaVuejs /> },
    ],
  },
  {
    name: "Back End",
    items: [
      { name: "PHP", icon: <FaPhp /> },
      { name: "Python", icon: <FaPython /> },
      { name: "Node.js", icon: <FaNodeJs /> },
      { name: ".NET", icon: <SiDotnet /> },
      { name: "Java", icon: <FaJava /> },
      { name: "Onnx", icon: <SiOnnx /> },
      { name: "Django", icon: <SiDjango /> },
      { name: "Mlflow", icon: <SiMlflow /> },

    ],
  },
  {
    name: "Databases",
    items: [

      { name: "MariaDB", icon: <SiMariadb /> },
      { name: "SQLite", icon: <SiSqlite /> },
      { name: "Mongodb", icon: <SiMongodb /> },
      { name: "Postgres", icon: <SiPostgresql /> },
      { name: "Mysql", icon: <SiMysql /> },
    ],
  },
  {
    name: "Cloud",
    items: [
      { name: "AWS", icon: <FaAws /> },

      { name: "Google Cloud", icon: <SiGooglecloud /> },
    ],
  },
];

const TechnologiesTab = () => {
  const [activeTab, setActiveTab] = useState("Front End");
  const currentTab = tabs.find((tab) => tab.name === activeTab);

  return (
    <>
      <section className="relative py-10 text-white font-recoleta">
        {/* Background Image */}
        <img
          src={Team}
          alt="img"
          className="absolute inset-0 w-full h-full object-cover z-0"
        />

        {/* Optional dark overlay */}
        <div className="absolute inset-0 z-0"></div>

        {/* Content */}
        <div className="relative z-1 container mx-auto px-4">
          {/* Title */}
          <div className="text-center mb-8">
            <h2 data-aos="fade-up" className="2xl:text-[40px] lg:text-[32px] text-[54px] font-bold mb-2">
              <strong> Technologies</strong> We Work With
            </h2>
            <p data-aos="fade-up" className="2xl:text-[26px]  lg:text-[20px] text-[34px]">
              Used to build interactive dashboards, data entry forms, prediction interfaces, and real-time model outputs.{" "}
              {/* <a href="/our-clients" className="text-white underline">
                our clients
              </a> */}
            </p>
          </div>

          {/* Tabs */}
          <div className="flex flex-wrap justify-center lg:gap-4 gap-8 mb-8">
            {tabs.map((tab) => (
              <button
                key={tab.name}
                onClick={() => setActiveTab(tab.name)}
                className={`px-4 2xl:text-[24px]  lg:text-[20px] text-[23px] py-2 rounded-3xl w-[150px] font-medium transition ${activeTab === tab.name
                  ? "bg-white text-black shadow"
                  : "bg-transparent text-white border border-white hover:text-white hover:border-white"
                  }`}
              >
                {tab.name}
              </button>
            ))}
          </div>

          {/* Tab Content */}
          <div className=" grid lg:grid-cols-3 lg:px-40 grid-cols-2 justify-center gap-4">
            {currentTab?.items.map((tech) => (
              <div
                key={tech.name}
                data-aos="fade-up"
                className="bg-white text-black  p-10 lg:mt-0 mt-10 rounded-lg shadow flex flex-col items-center justify-center"
              >
                <div className="lg:text-4xl  text-[80px] mb-2">{tech.icon}</div>
                <p className="2xl:text-[24px]  lg:text-[20px] text-[60px] font-medium text-center">{tech.name}</p>
              </div>
            ))}
          </div>
        </div>
      </section>

    </>

  );
};

export default TechnologiesTab;
